module.exports = __webpack_public_path__ + "static/media/light_pr_bg.c7157005.jpg";